import {Component, EventEmitter, Output} from '@angular/core'
import {LengthTextFieldValidator} from './length-text-field-validator'
import {NumericTextFieldValidator} from './numeric-text-field-validator'
import {Validatable} from './validatable'
import {FormValidationService} from './form-validation-service'

@Component({
  selector: 'ValidatedSSNInputFields',
  templateUrl: './html-templates/validated-ssn-input-fields.component.html'
})
export class ValidatedSSNInputFields extends Validatable<string> {
  @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()

  private area: string
  private group: string
  private serial: string

  validators = [new LengthTextFieldValidator(9), new NumericTextFieldValidator()]

  constructor(formValidationService: FormValidationService) {
    super(formValidationService)
  }

  onAreaChange(newValue: string) {
    this.area = newValue
    this.onValueChange.emit(this.getValue())
  }

  onGroupChange(newValue: string) {
    this.group = newValue
    this.onValueChange.emit(this.getValue())
  }

  onSerialChange(newValue: string) {
    this.serial = newValue
    this.onValueChange.emit(this.getValue())
  }

  getErrorMessages() {
    if (this.errorMessages.length) {
      return ['Invalid SSN']
    } else {
      return []
    }
  }

  getValue(): string {
    return `${this.area}${this.group}${this.serial}`
  }

  getLabel(): string {
    return ''
  }
}
